import styles from '../styles/successAuth.module.scss';
import { CheckOutlined } from '@ant-design/icons';

export default function SuccessIcon() {
    return (
        <div className={styles.successIcon} aria-hidden>
            <span className={styles.successIconRippleOuter} />
            <span className={styles.successIconRippleInner} />
            <span className={styles.successIconCore}>
                <CheckOutlined className={styles.successIconCheck} />
            </span>
        </div>
    );
}